function setAccordionHeights() {
    $( ".accordion-item-inner" ).each(function( index ) {
       let itemHeight = $(this).height();
       $(this).attr('data-height', `${itemHeight + 30}px`);
    });
}

$(document).ready(function() {
    setAccordionHeights();
});

window.addEventListener('resize', function(event) {
    setAccordionHeights();
}, true);


$('.accordion-item-title').click(function() {

    let itemHeight = $(this).siblings('.accordion-item-copy').find('.accordion-item-inner').attr('data-height');

    if($(this).parent().hasClass("open-accordion")) {
        $(this).parent().removeClass('open-accordion');
        $(this).siblings('.accordion-item-copy').css('max-height', 0)
    }
    else {
        $(this).parent().addClass('open-accordion');
        $(this).siblings('.accordion-item-copy').css('max-height', itemHeight)
    }

}); 